<template>
  <q-input
    v-model="searchQuery"
    :float-label="placeholder"
    clearable
    :disable="disable"
    @clear="clear"
    @input="clear"
  >
    <q-autocomplete
      :min-characters="minCharacters"
      :max-results="20"
      @search="runSearch"
      @selected="itemSelected"
    />
  </q-input>
</template>

<script>
import { ref } from '@vue/composition-api';
import { search } from '@/utils/SearchUtil';

export default {
  name: 'Autocomplete',
  props: {
    method: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    filters: {
      type: Object,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    minCharacters: {
      type: Number,
      default: 2,
    },
  },
  setup(props, context) {
    const searchQuery = ref(null);

    return {
      searchQuery,
      runSearch,
      itemSelected,
      clear,
    };

    async function runSearch(query, done) {
      const filters = props.filters || {};
      const items = await search(query, props.method, filters);
      done(items);
    }
    function itemSelected(item, navigateWithKeyboardArrows) {
      if (navigateWithKeyboardArrows) {
        return;
      }
      context.emit('change', { item, navigateWithKeyboardArrows });
    }
    function clear() {
      context.emit('clear', { item: null, navigateWithKeyboardArrows: false });
    }
  },
};
</script>
